import React, { Component, PropTypes } from 'react';
import { Button } from 'reactstrap';
import ConfirmLink from 'react-confirm-dialog';

import NavBar from './NavBar';
import NavLink from './NavLink';
import  { CREATE, EDIT } from "../components/AssignmentForm";
import { spaceToUnderscore } from "../helpers/helpers";

class AssignmentFormLinks extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { assignment, dropbox, handleDelete, handleExit, handleSubmit } = this.props;

        if (this.props.type === CREATE) {
            return (
                <NavBar
                    className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                >
                    <NavLink
                        to={`/?expand=${dropbox.id}`}
                        className="btn btn-outline-primary btn-md"
                        side="left"
                        display
                        key="exit"
                    >
                        Exit <i className={"fa fa-chevron-circle-left"}/>
                    </NavLink>
                    <NavLink
                        to="submit"
                        className=""
                        side="right"
                        display
                        key="submit"
                    >
                        <Button
                            type="button"
                            onClick={handleSubmit}
                            size="md"
                            color="success"
                            title={'Create Assignment'}
                        >
                            Create
                        </Button>
                    </NavLink>
                </NavBar>
            );
        }

        if (this.props.type === EDIT) {
            return (
                <NavBar
                    className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                >
                    <NavLink
                        to={`/?expand=${dropbox.id}`}
                        className=""
                        side="left"
                        display
                        key="exit"
                    >
                        <Button
                            type="button"
                            onClick={handleExit}
                            size="md"
                            color="outline-primary"
                            title={'Exit'}
                        >
                            Exit <i className={"fa fa-chevron-circle-left"}/>
                        </Button>
                    </NavLink>
                    <NavLink
                        to="submit"
                        className=""
                        side="right"
                        display
                        key="submit"
                    >
                        <Button
                            type="button"
                            onClick={handleSubmit}
                            size="md"
                            color="success"
                            title={"Save Assignment"}
                        >
                           Save
                        </Button>
                    </NavLink>
                    <NavLink
                        to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/copy`}
                        className=""
                        side="right"
                        display
                        key="copy"
                    >
                        <button
                            type="button"
                            className="btn btn-info"
                            title={"Copy Assignment"}
                        >
                            Copy
                        </button>
                    </NavLink>
                    <NavLink
                        to="delete"
                        className=""
                        side="right"
                        display
                        key="delete"
                        onClick={(e) => {
                            e.preventDefault();
                        }}
                    >
                        <ConfirmLink
                            action={handleDelete}
                            actionArgs={{dropbox_id: dropbox.id, assignment_id: assignment.id}}
                            confirmMessage={`Are you sure you want to delete assignment: ${assignment.name}`}
                            confirmText={"Yes"}
                            cancelText={"No"}
                        >
                            <button
                                type="button"
                                className="btn btn-danger"
                                title={"Delete Assignment"}
                            >
                                Delete
                            </button>
                        </ConfirmLink>
                    </NavLink>
                    <NavLink
                        to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/groups`}
                        className=""
                        side="right"
                        display={assignment.group_submission}
                        key="groups"
                    >
                        <button
                            className="btn btn-md btn-warning"
                            type="button"
                        >
                            All Groups &nbsp;
                            <i className="fa fa-users" aria-hidden="true"/>
                        </button>
                    </NavLink>
                </NavBar>
            );
        }

        return null;
    }
}


AssignmentFormLinks.propTypes = {
    assignment: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    dropbox: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleDelete: PropTypes.func,
    handleExit: PropTypes.func,
    type: PropTypes.string.isRequired
};

export default AssignmentFormLinks;


/** WEBPACK FOOTER **
 ** ./src/components/AssignmentFormLinks.js
 **/